<template>
    <div>
    </div>
</template>
<script>
import VConsole from 'vconsole';
import { firstApi } from '../http/api.js';
export default {
    name: 'tearcher',
    data() {
        return {

        }
    },
    mounted() {
        // try {
        //     const vConsole = new VConsole();
        //     console.log('vconsole 初始化成功', vConsole);
        //     // 强制显示 vconsole 面板
        //     setTimeout(() => {
        //         if (vConsole && typeof vConsole.show === 'function') {
        //             vConsole.show();
        //             console.log('vconsole 已显示');

        //         }
        //     }, 0);

        // } catch (error) {
        //     console.error('vconsole 初始化失败:', error);
        // }
         let url = new URL(window.location.href);
        // //这里需要解码
        // url = new URL(decodeURIComponent(url.href));
         let parms = url.searchParams.get('response')
        // console.log('parms:', parms);
        // let id = url.searchParams.get('id')
        // let token = url.searchParams.get('token')
        const params = this.getUrlParams();
        const id = params.id;
        const token = params.token;
        console.log('id:', id);
        console.log('token:', token);
        if (id && token) {
            window.localStorage.setItem('token', token)
            this.geturl(id)
        }
        if (parms) {
            //  this.certifyId = JSON.parse(parms).extInfo.certifyId
            this.handleError(JSON.parse(parms).code, JSON.parse(parms).subCode)
        }

    },
    methods: {
        getUrlParams() {
            const search = window.location.search.slice(1);
            // 先解码整个参数字符串，再分割
            const paramsStr = decodeURIComponent(search);
            const params = {};
            paramsStr.split('&').forEach(item => {
                const [key, value] = item.split('=');
                if (key) {
                    params[key] = value ? decodeURIComponent(value) : '';
                }
            });
            return params;
        },
        geturl(id) {
            const MetaInfo = window.getMetaInfo();
            MetaInfo.TerminalType = "H5"
            firstApi.planInitFaceVerify({ enrollId: id, metaInfoVo: MetaInfo }).then(res => {
                console.log(res, 'url接口');
                if (res.code == 1) {
                    window.location.href = res.data.certifyUrl;
                } else {
                    alert(res.msg)
                    wx.miniProgram.navigateBack({
                        // delta 表示回退的页面层数，1 代表返回上一级页面
                        delta: 1,
                        success: () => {

                        },
                        fail: (err) => {
                            alert(err.errMsg)
                        }
                    });
                }
            })
        },
        handleError(code, subCode) {
            if (code == 1000) {
                alert("人脸验证成功。");
            } else if (code == 1001) {
                alert("表示系统错误。");
                //跳回登录

            } else if (code == 1003) {

                switch (subCode) {
                    case 'Z5051':
                        alert("上传刷脸图片失败。");
                        break;
                    case 'Z5052':
                        alert("数据错误或程序异常。");
                        break;
                    case 'Z5053':
                        alert("网络错误。");
                        break;
                    case 'Z5054':
                        alert("摄像头无权限或无法获取摄像头数据。");
                        break;
                    case 'Z5055':
                        // alert("用户退出。");
                        break;
                    case 'Z5056':
                        alert("重试次数过多。");
                        break;
                    case 'Z5058':
                        alert("视频格式不满足要求。");
                        break;
                    case 'Z5059':
                        alert("视频中无有效人脸。");
                        break;
                    default:
                        alert("未知错误：" + subCode);
                }
            } else if (code == 2002) {

                alert("表示网络错误。");
                //  this.$route.push('/pages/signIn/signIn')
            } else if (code == 2003) {
                alert("表示客户端设备时间错误。");
                //  this.$route.push('/pages/signIn/signIn')
            } else if (code == 2006) {
                //   this.$route.push('/pages/signIn/signIn')
                if (subCode === 'Z5128') {
                    alert("刷脸验证失败，认证未通过。可通过服务端查询接口获取认证未通过具体原因。");

                } else if (subCode === 'Z5052') {
                    alert("客户端提交认证数据到服务端处理结果异常，未进入认证流程。");
                } else {
                    alert("未知错误：" + subCode);
                }
            } else {
                alert("未知错误码：" + code);
            }
            wx.miniProgram.navigateBack({
                // delta 表示回退的页面层数，1 代表返回上一级页面
                delta: 1,

            });
            // 替换原有 redirectTo 跳转逻辑，改为页面回退

        },
    }
}
</script>
<style scoped></style>